import { hotTopics } from "@/mocks/gossip";

const deltaIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-600" },
  new: { icon: "ri-sparkling-2-line", cls: "text-accent-600" },
  flat: { icon: "ri-arrow-right-line", cls: "text-secondary-500" },
};

export default function HotTopics() {
  const left = hotTopics.filter((_, i) => i % 2 === 0);
  const right = hotTopics.filter((_, i) => i % 2 === 1);

  const renderColumn = (col: typeof hotTopics) =>
    col.map((t) => {
      const d = deltaIcon[t.delta];
      const top3 = t.rank <= 3;
      return (
        <a
          key={t.rank}
          href="#hot"
          className="group flex items-center gap-3 rounded-lg px-2 py-2.5 transition-colors hover:bg-background-50"
        >
          <span
            className={`w-7 shrink-0 text-center font-display text-xl font-bold ${
              top3 ? "text-primary-600" : "text-secondary-300"
            }`}
          >
            {t.rank}
          </span>
          <span className="flex-1">
            <span className="block truncate text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
              {t.title}
            </span>
            <span className="mt-0.5 flex items-center gap-2 text-xs text-foreground-400">
              <span className="rounded bg-secondary-100 px-1.5 py-px text-secondary-700">
                {t.category}
              </span>
              <span className="flex items-center gap-0.5">
                <i className="ri-fire-line h-3 w-3 flex items-center justify-center text-accent-500" />
                {t.heat}
              </span>
            </span>
          </span>
          <i
            className={`${d.icon} h-4 w-4 flex items-center justify-center ${d.cls}`}
          />
        </a>
      );
    });

  return (
    <section
      id="trend"
      className="scroll-mt-24 w-full bg-gradient-to-b from-background-50 via-background-100 to-background-50 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-wide text-accent-600">
              <i className="ri-fire-fill h-4 w-4 flex items-center justify-center" />
              TRENDING · 实时热搜
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              全站热榜 TOP 10
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              由全网声量与本站热度综合排序，关注度实时浮动。
            </p>
          </div>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-radio-button-line h-3.5 w-3.5 flex items-center justify-center text-primary-500 animate-pulse" />
            更新于刚刚 · 数据每 5 分钟刷新
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-x-8 gap-y-1 rounded-xl border border-background-200 bg-background-100/70 p-4 md:grid-cols-2 md:p-6 lg:p-8">
          <div className="flex flex-col divide-y divide-background-200/80">
            {renderColumn(left)}
          </div>
          <div className="flex flex-col divide-y divide-background-200/80 border-t border-background-200/80 pt-1 md:border-l md:border-t-0 md:pl-8">
            {renderColumn(right)}
          </div>
        </div>
      </div>
    </section>
  );
}